<template>
  <div class="prescriberTreatmentAreaDetails">
    <pds-card>
      <template v-slot>
        <div class="flex item-start">
          <div class="flex-shrink-0"><v-pen></v-pen></div>
          <div class="flex-1">
            <div class="text-2xl font-semibold leading-6 flex-1 mx-2">Behandelgebieden wijzigen</div>
          </div>
        </div>
        <div class="grid my-2">
          <div
            class="relative flex items-start py-2"
            v-for="(treatmentArea, index) in editableTreatmentAreas"
            :key="index"
          >
            <div class="flex h-6">
              <input
                :id="treatmentArea.id"
                :aria-describedby="treatmentArea.id"
                name="prescriberTreatmentArea"
                type="checkbox"
                v-model="treatmentArea.active"
                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
              />
            </div>
            <div class="ml-3">
              <label for="notificationOn" class="text-black">
                {{ treatmentArea.description }}
              </label>
            </div>
          </div>
        </div>
        <div class="row justify-end">
          <v-button md cta hollow transparent @click="cancelTreatmentAreaDetailsSave"> Annuleren </v-button>
          <v-button md cta @click.prevent="saveTreatmentAreaDetails"> Wijzigen </v-button>
        </div>
      </template>
    </pds-card>
  </div>
</template>
<script>
import { ref, onMounted, getCurrentInstance } from 'vue';
import axios from 'axios';
import VPen from 'icons/Pen';
import { allTreatmentAreas$ } from '@/services';

export default {
  name: 'PrescriberTreatmentAreaDetails',
  components: { VPen },
  props: {
    treatmentAreaDetails: {
      type: Array,
      required: true
    }
  },
  emits: ['cancel', 'save'], // Declare emitted events
  setup(props, { emit }) {
    const $emitter = getCurrentInstance().appContext.config.globalProperties.$emitter;
    const allTreatmentAreas = ref(null);
    const editableTreatmentAreas = ref([]);
    // Fetch all treatment areas
    allTreatmentAreas$.subscribe((value) => {
      allTreatmentAreas.value = value;

      // Initialize editableTreatmentAreas based on props and allTreatmentAreas
      const utas = props.treatmentAreaDetails.map((m) => m.treatmentAreaId);
      editableTreatmentAreas.value = allTreatmentAreas.value.map((m) => ({
        ...m,
        active: utas.includes(m.id),
        treatmentAreaId: m.id
      }));
    });

    onMounted(() => {});

    const cancelTreatmentAreaDetailsSave = () => {
      emit('cancel');
    };
    const saveTreatmentAreaDetails = () => {
      editableTreatmentAreas.value.map((area) => ({
        id: area.id,
        active: area.active
      }));
      axios
        .post('UserV2/UpdateUserTreatmentAreas', {
          UserTreatmentArea: editableTreatmentAreas.value
        })
        .then((response) => {
          emit('save', response.data);
        });
    };

    return {
      emit,
      cancelTreatmentAreaDetailsSave,
      saveTreatmentAreaDetails,
      editableTreatmentAreas
    };
  }
};
</script>
<style lang="scss" scoped>
.prescriberTreatmentAreaDetails {
  color: $teal-darkest;
  .material-design-icon {
    fill: $teal-darkest;
  }
}
</style>
